/**
 * @author Christine Movius
 * @desc multisite sections list component for global use
 * @example <multisite-sections-list
 *               website-hierarchy="$ctrl.websiteHierarchy"
 *               param-type="$ctrl.paramType"
 *               render-checkbox="boolean"
 *               render-search="boolean"
 *               selected-sections="$ctrl.selectedSections"
 *               website-sections="$ctrl.websiteSections"
 *               on-change-selected-sections="$ctrl.onChangeSelectedSections(websiteSectionArr)">>
 *          </multisite-sections-list>
*/

import template from './multisiteSectionsList.html';

const multisiteSectionsList = {
  template,
  bindings: {
    websiteHierarchy: '<',
    paramType: '<',
    renderCheckbox: '<',
    renderSearch: '<',
    selectedSections: '<',
    websiteSections: '<',
    onChangeSelectedSections: '&'
  }
};

export default function (ngModule) {
  ngModule.component('multisiteSectionsList', multisiteSectionsList);
}
